import { gql } from '@provision/graphql-client';

export const PARTNER_HOLIDAY_FRAGMENT = gql`
  fragment PartnerHolidayFields on PartnerHoliday {
    id
    partnerHolidayId
    partnerId
    holidayName
    holidayStart
    holidayEnd
    submitterId
    platformUser {
      id
      userId
      firstName
      lastName
    }
  }
`;
